import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import { convertDataRpToRecord } from '../utils/dataModificaionUtil';

/**
 * Custom hook to handle UNiD product validation and related UI state updates.
 * @param {Object} params - All dependencies and setters required for the effect.
 */
export function useValidUnidProductsEffect({
    validUnidProducts,
    filteredProduct,
    showReportPayment,
    getValidatedItemTableData,
    myCaseResourceType,
    setFilteredProduct,
    setIsReplishBtnClicked,
    setShowUNiDPopUp,
    patientIdMandatory,
    patientDetails,
    myCaseRefId,
    getValidateItemsArr,
    dispatch,
    validateProductDetails
}) {
    useEffectWithErrorLogging(() => {
        if (
            validUnidProducts &&
            validUnidProducts.length > 0 &&
            filteredProduct.length > 0 &&
            !showReportPayment
        ) {
            const validatedItemTableData = getValidatedItemTableData(
                filteredProduct,
                validUnidProducts,
                myCaseResourceType
            );
            setFilteredProduct(validatedItemTableData);
            const usedQty = validatedItemTableData?.some(
                (item) =>
                    item.lotSerial?.[0]?.used ||
                    item.children?.some((item) => item.lotSerial?.[0]?.used)
            );
            const otherQty = validatedItemTableData?.some(
                (item) =>
                    item.lotSerial?.[0]?.other ||
                    item.children?.some((item) => item.lotSerial?.[0]?.other)
            );
            usedQty || otherQty
                ? validatedItemTableData?.some(
                      (item) =>
                          item.isUNiDPlanFeeItem === true ||
                          item.children?.some(
                              (item) => item.isUNiDPlanFeeItem === true
                          )
                  )
                    ? (setIsReplishBtnClicked(false), setShowUNiDPopUp(false))
                    : (setIsReplishBtnClicked(true), setShowUNiDPopUp(true))
                : null;

            if (
                validatedItemTableData.some(
                    (item) =>
                        item.isUNiDPlanFeeItem === true ||
                        item.children?.some(
                            (item) => item.isUNiDPlanFeeItem === true
                        )
                )
                    ? (patientIdMandatory
                          ? patientDetails?.hrefId?.length > 0
                          : true) &&
                      filteredProduct.length > 0 &&
                      myCaseRefId
                    : null
            ) {
                const validateItemsArr = getValidateItemsArr(convertDataRpToRecord(filteredProduct));
                validateItemsArr.map(
                    (item) =>
                        item.accountOwned == undefined &&
                        delete item.accountOwned
                );
                const validateItemsObj = {
                    myCaseRef: myCaseRefId,
                    products: validateItemsArr,
                };
                dispatch(validateProductDetails(validateItemsObj, true));
                dispatch({
                    type: 'SET_ITEMS_PRICING_DONE_FLAG',
                    payload: false,
                });
            }
        }
    }, [validUnidProducts]);
}
